import { WaveTypeMapping } from '../wave/types/wave.type';

// Graph
export const gridLineColor = 'rgba(255, 165, 0, 1)';

// Waves
export const typeToColor: WaveTypeMapping = {
  artifact: '#8c564b',
  noise: '#7e7e7e',
  calibration: '#0e5200',
  P: '#1d31cc',
  QRS: '#ff4c0b',
  T: '#5dc31e',
  no_signal: '#8400ff',
  p_level_noise: '#1d31cc',
  qrs_level_noise: '#ff4c0b',
  pt_level_noise: '#00f915',
  uncertain: '#ff00b3',
  microvolted: '#17becf',
};

export const waveOpacity = 0.2;
export const manualWaveOpacity = 0.5;

// Ruler
export const rulerBackground = 'rgba(135, 139, 149, 0.25)';

// Leads
export const LEAD_COLOR_SCHEME = [
  '#1f77b4',
  '#17becf',
  '#ff7f0e',
  '#ffbb78',
  '#2ca02c',
  '#98df8a',
  '#d62728',
  '#ff9896',
  '#9467bd',
  '#e377c2',
  '#8c564b',
  '#c49c94',
];

// Metrics
export const metricSignificant = '#f6a623';
export const metricUrgent = '#f02548';

// Laddergram
export const QRSWaveRed = '#ff4e0b';
export const PWaveBlue = '#1d31cc';

// Donut
export const donutRed = '#ff5c4d';
export const donutOrange = '#faad14';
export const donutGreen = '#73d13d';

// Graph
export const greyBorder = '#eff0f2';
export const greenLine = '#73d13d';
